import State from 'store/State';
import { selectComponentKeysByType } from 'layout/store/selectors';
import { WidgetType } from 'widgets/WidgetType';
import { selectWidgetInstancesState } from 'widgets/store/selectors';

export const selectVolumeCurveWidgetKeys: (state: State) => string[] = (
    state
) => selectComponentKeysByType(state, WidgetType.VOLUME_CURVE);

export const selectVolumeCurvesWidgetsState = (state: State) =>
    selectWidgetInstancesState(state)[WidgetType.VOLUME_CURVE];

export const selectVolumeCurveState = (state: State, widgetKey: string) =>
    selectVolumeCurvesWidgetsState(state)[widgetKey];
